import bowser from 'bowser';

import { PLATFORM_TYPE } from '../constants';

const getUserAgentParser = () => {
  return bowser.getParser(window.navigator.userAgent);
};

export const getUserAgentFullDetails = () => {
  const parser = getUserAgentParser();
  return parser.getResult();
};

export const getUserAgentBrowserDetails = () => {
  const parser = getUserAgentParser();
  return parser.getBrowser();
};

export const getUserAgentBrowserEngineDetails = () => {
  const parser = getUserAgentParser();
  return parser.getEngine();
};

export const getUserAgentOperatingSystemDetails = () => {
  const parser = getUserAgentParser();
  return parser.getOS();
};

export const getUserAgentPlatformDetails = () => {
  const parser = getUserAgentParser();
  return parser.getPlatform();
};

export const getIsUserPlatformMobile = () => {
  const platform = getUserAgentPlatformDetails();
  return platform?.type === PLATFORM_TYPE.MOBILE;
};

export const getIsUserPlatformTablet = () => {
  const platform = getUserAgentPlatformDetails();
  return platform?.type === PLATFORM_TYPE.TABLET;
};

export const getIsUserPlatformSupportTouchEvents = () => {
  return window.navigator.maxTouchPoints > 0;
};

export const getIsUserPlatformDesktop = () => {
  const platform = getUserAgentPlatformDetails();
  return platform?.type === PLATFORM_TYPE.DESKTOP;
};

export const getIs64Bit = () => {
  return window.navigator.userAgent.includes('WOW64') || window.navigator.userAgent.includes('Win64');
};

export const isChromeNewerOrEqualVersion = (minVer: string) => {
  const parser = getUserAgentParser();
  return parser.satisfies({ chrome: `>=${minVer}` });
};
